import React from 'react'
import { Card } from 'reactstrap';

const JobSeekerAbout = ({ profileData }) => {

  let aboutMe = profileData?.profile?.about_me ?? 'Add something about yourself';
  const preferred_job_types = Array.isArray(profileData?.preferred_job_types) ? profileData.preferred_job_types : [];

  return (
    <>
      <div className="row candidate-profile mb-3 border rounded border-primary">
        <div className="d-flex justify-content-between">
          <h4>About Me</h4>
        </div>
        <p>
          {
            aboutMe ? aboutMe : 'Add something about yourself'
          }
        </p>
        <div className='col-md-12'>
          <Card className="candidate-profile mb-3 border rounded border-primary">
            <div className='p-0 p-md-3'>
              <div className="d-flex align-items-center justify-content-between">
                <div className="overflow-hidden">
                  <h4 className="fw-medium text-truncate mb-0 pb-1 text-start border-bottom border-2 border-primary">
                    Open To Job Types
                  </h4>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div className="text-start">
                  <h5 className="fw-medium fs-1">
                    {preferred_job_types[0]?.full_time &&
                      <span className={`badge me-2 ${preferred_job_types[0]?.full_time ? "bg-primary text-light" : "bg-light text-primary"}`}
                        style={{
                          fontSize: "12px",
                          border: "1px solid #3e6a9f",
                          borderRadius: "5px"
                        }}
                      >
                        Full-time
                      </span>}

                    {preferred_job_types[0]?.part_time &&
                      <span className={`badge me-2 ${preferred_job_types[0]?.part_time ? "bg-primary text-light" : "bg-light text-primary"}`}
                        style={{
                          fontSize: "12px",
                          border: "1px solid #3e6a9f",
                          borderRadius: "5px"
                        }}
                      >
                        Part-time
                      </span>}

                    {preferred_job_types[0]?.temporary &&
                      <span className={`badge me-2 ${preferred_job_types[0]?.temporary ? "bg-primary text-light" : "bg-light text-primary"}`}
                        style={{
                          fontSize: "12px",
                          border: "1px solid #3e6a9f",
                          borderRadius: "5px"
                        }}
                      >
                        Temporary
                      </span>}

                    {preferred_job_types[0]?.contract &&
                      <span className={`badge me-2 ${preferred_job_types[0]?.contract ? "bg-primary text-light" : "bg-light text-primary"}`}
                        style={{
                          fontSize: "12px",
                          border: "1px solid #3e6a9f",
                          borderRadius: "5px"
                        }}
                      >
                        Contract
                      </span>}

                    {preferred_job_types[0]?.internship &&
                      <span className={`badge me-2 ${preferred_job_types[0]?.internship ? "bg-primary text-light" : "bg-light text-primary"}`}
                        style={{
                          fontSize: "12px",
                          border: "1px solid #3e6a9f",
                          borderRadius: "5px"
                        }}
                      >
                        Internship
                      </span>}
                  </h5>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default JobSeekerAbout